import { render, staticRenderFns } from "./BacLiabilityDisclaimer.vue?vue&type=template&id=24174eeb&"
import script from "./BacLiabilityDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./BacLiabilityDisclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports